import React from 'react';

type KoobPillGroupProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'className'
>;

const KoobPillGroup = React.forwardRef<HTMLDivElement, KoobPillGroupProps>(
  (props, ref) => (
    <div ref={ref} className="flex flex-wrap items-center gap-2" {...props} />
  ),
);
KoobPillGroup.displayName = 'KoobPillGroup';

export { KoobPillGroup };
